// import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
// import { db } from "../../firebase-config";

// export const getFilteredPackages = async ({
//   packageType = "all",
//   instructorIds = [],
//   priceFilter = "all",
//   searchTerm = "",
// }) => {
//   try {
//     let q = collection(db, "lms_package");

//     const constraints = [];

//     // Package Type filter
//     if (packageType && packageType !== "all") {
//       constraints.push(where("packageType", "==", packageType));
//     }

//     // Instructor filter (Firebase doesn't support "in" for arrays > 10, so handle carefully)
//     if (instructorIds.length > 0) {
//       constraints.push(where("trainerId", "in", instructorIds.slice(0, 10))); // Firestore limit
//     }

//     // Search filter (Firestore doesn't support contains like SQL, so use startAt/endAt or implement on frontend for large text)
//     if (searchTerm.trim() !== "") {
//       constraints.push(where("packageName", ">=", searchTerm));
//       constraints.push(where("packageName", "<=", searchTerm + "\uf8ff"));
//     }

//     // Build query
//     if (constraints.length > 0) {
//       q = query(q, ...constraints);
//     }

//     const querySnapshot = await getDocs(q);
//     let packages = querySnapshot.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(),
//     }));

//     // Price sorting/filtering handled after query
//     if (priceFilter === "low-to-high") {
//       packages.sort((a, b) => (a.packagePrice || 0) - (b.packagePrice || 0));
//     } else if (priceFilter === "high-to-low") {
//       packages.sort((a, b) => (b.packagePrice || 0) - (a.packagePrice || 0));
//     } else if (priceFilter === "paid") {
//       packages = packages.filter((pkg) => (pkg.packagePrice || 0) > 0);
//     } else if (priceFilter === "free") {
//       packages = packages.filter((pkg) => (pkg.packagePrice || 0) === 0);
//     }

//     return packages;
//   } catch (err) {
//     console.error("Error fetching filtered packages:", err);
//     return [];
//   }
// };
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

export const getFilteredPackages = async ({
  packageType = "all",
  instructorIds = [],
  priceFilter = "all",
  searchTerm = "",
}) => {
  try {
    let q = collection(db, "lms_package");
    const constraints = [];

    // Package Type filter
    if (packageType && packageType !== "all") {
      constraints.push(where("packageType", "==", packageType));
    }

    // Instructor filter (Firestore "in" supports max 10)
    if (instructorIds.length > 0) {
      constraints.push(where("trainerId", "in", instructorIds.slice(0, 10)));
    }

    // Build query with constraints
    if (constraints.length > 0) {
      q = query(q, ...constraints);
    }

    const querySnapshot = await getDocs(q);
    let packages = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Case-insensitive search
    if (searchTerm.trim() !== "") {
      const term = searchTerm.toLowerCase();
      packages = packages.filter((pkg) =>
        (pkg.packageName_lower || pkg.packageName || "")
          .toLowerCase()
          .includes(term)
      );
    }

    // Price sorting/filtering
    if (priceFilter === "low-to-high") {
      packages.sort((a, b) => (a.packagePrice || 0) - (b.packagePrice || 0));
    } else if (priceFilter === "high-to-low") {
      packages.sort((a, b) => (b.packagePrice || 0) - (a.packagePrice || 0));
    } else if (priceFilter === "paid") {
      packages = packages.filter((pkg) => (pkg.packagePrice || 0) > 0);
    } else if (priceFilter === "free") {
      packages = packages.filter((pkg) => (pkg.packagePrice || 0) === 0);
    }

    return packages;
  } catch (err) {
    console.error("Error fetching filtered packages:", err);
    return [];
  }
};
